<template>
  <div class="wise-route-shell" />
</template>

<script>
export default {
  name: 'WiseView',
};
</script>
